@import '../../../theme.scss';

verdocs-field-textarea {
  width: 150px;
  height: 15px;
  display: block;
  font-size: 11px;
  position: relative;
  scroll-margin: 20px 0;
  box-sizing: border-box;
  background-color: var(--verdocs-field-background, transparent);
  transform-origin: bottom left;
  font-family: $verdocs-primary-font;
  border: var(--verdocs-field-border, 1px solid rgba(0, 0, 0, 0.2));
  border-radius: var(--verdocs-field-radius);

  textarea {
    // This is needed to bring down the cursor from the parent element, which is where interactjs applies it
    cursor: inherit;

    width: 100%;
    height: 100%;
    resize: none;
    border: none;
    outline: none;
    padding: 0 3px;
    font-size: 11px;
    background: none;
    font-weight: 500;
    transform-origin: 0 0;
    box-sizing: border-box;
    color: var(--verdocs-field-text-color, rgba(0, 0, 0, 0.87));

    &.hide {
      display: none;
    }
  }

  &.disabled textarea {
    opacity: 0.5;
  }

  label {
    top: -14px;
    left: -1px;
    height: 14px;
    color: white;
    padding: 0 4px;
    font-size: 9px;
    line-height: 13px;
    position: absolute;
    background: #4a4a99;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  &.required {
    &.required {
      border: 1px solid var(--verdocs-required-field-border);
    }
  }

  verdocs-button-panel {
    top: -3px;
    left: -2px;
    opacity: 0.5;
    z-index: 1000;
    cursor: pointer;
    position: absolute;
    transform: scale(0.6);

    &[data-active],
    &:hover {
      opacity: 1;
    }

    .icon {
      svg {
        fill: #333333;
      }

      &:hover {
        svg {
          fill: #000000;
        }
      }
    }
  }

  .settings-icon {
    position: absolute;
    top: -3px;
    left: -20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.3;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }
}
